import React, { useContext, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import styles from "./LoginV2.module.scss";
import NavContext from "../../context/NavContext";
import logo from "../../pics/logo-hearingspace.png";
import LoaderLogin from "../../components/UiComponents/loader/LoaderLogin";
import ForgotPassword from "../../components/authentification/ForgotPassword";

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08, delayChildren: 0.2 } },
};

const item = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export default function Login({ setRememberMe }) {
  const { loginUser, loaderLogin } = useContext(NavContext);
  const { t } = useTranslation();

  const [userMail, setUserMail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  axios.defaults.withCredentials = true;

  const submitForms = async (e) => {
    e.preventDefault();
    await loginUser(userMail, userPassword);
  };

  if (showForgot) {
    return (
      <div className={styles.page}>
        <ForgotPassword showForgot={showForgot} setShowForgot={setShowForgot} />
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <motion.div
        className={styles.card}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {/* Panneau marque */}
        <motion.div
          className={styles.brand}
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className={styles.shape1} />
          <div className={styles.shape2} />
          <div className={styles.shape3} />
          <div className={styles.brandContent}>
            <img src={logo} alt="HearingSpace" className={styles.logo} />
            <p className={styles.tagline}>{t("login.title")}</p>
          </div>
        </motion.div>

        {/* Panneau formulaire */}
        <div className={styles.formPanel}>
          <motion.div
            className={styles.formInner}
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            <motion.h1 variants={item} className={styles.heading}>
              {t("login.welcome")}
            </motion.h1>
            <motion.p variants={item} className={styles.subheading}>
              {t("login.email_label")}
            </motion.p>

            <form onSubmit={submitForms}>
              <motion.div variants={item} className={styles.field}>
                <label htmlFor="email">{t("login.email_label")}</label>
                <input
                  type="text"
                  id="email"
                  placeholder="user@example.com"
                  value={userMail}
                  onChange={(e) => setUserMail(e.target.value)}
                  required
                />
              </motion.div>

              <motion.div variants={item} className={styles.field}>
                <label htmlFor="password">{t("login.password_label")}</label>
                <div className={styles.passwordWrapper}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder={t("login.password_placeholder")}
                    value={userPassword}
                    onChange={(e) => setUserPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className={styles.eyeBtn}
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={
                      showPassword
                        ? t("login.hide_password")
                        : t("login.show_password")
                    }
                  >
                    {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </button>
                </div>
              </motion.div>

              <motion.div variants={item}>
                <motion.button
                  type="submit"
                  className={styles.submitBtn}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.97 }}
                >
                  {t("login.submit")}
                </motion.button>
              </motion.div>

              {loaderLogin && <LoaderLogin />}

              <motion.div
                variants={item}
                className={styles.forgot}
                onClick={() => setShowForgot(true)}
              >
                {t("login.forgot_password")}
              </motion.div>
            </form>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}
